<template>
  <ToastUndoComponent
    :text="$t('toasts.deleted_f', { var: $t('attributes.address') })"
  />
  <template v-if="initialMetadata?.models?.addresses.length < 1">
    <div class="mx-auto mt-12 text-center text-gray-400">
      {{
        $t('global.there_is_no_yet', { settings: $t('attribute.addresses') })
      }}
    </div>
  </template>
  <div v-else class="flex flex-col gap-3">
    <div class="flex justify-end">
      <BaseSimpleSearchInput
        v-model:model-value="filterText"
      />
    </div>

    <div class="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-5">
      <template v-for="(loop_address, index) in filteredAddresses" :key="index">
        <div class="cursor-pointer">
          <BaseCard
            :entry="loop_address"
            :options="options"
            :selected="
              fullModelResponse
                ? (loop_address = modelValue)
                : loop_address.id === modelValue
            "
            :select-entry="handleSelectAddress"
            title="name"
          >
            <template #card-details="{ entry: address }">
              <div
                class="flex-gap-1 pointer-events-none flex-1 text-center lg:text-left"
              >
                <div
                  v-if="address.street"
                  class="flex items-center justify-center text-gray-600 lg:justify-start"
                >
                  {{ address.street }}
                </div>
                <div
                  v-if="address.city"
                  class="flex items-center justify-center text-gray-600 lg:justify-start"
                >
                  {{ address.zip }} {{ address.city }}
                </div>
                <div
                  v-if="address.country"
                  class="flex items-center justify-center text-gray-600 lg:justify-start"
                >
                  {{
                    initialMetadata?.enums?.countries?.find(
                      (country) => country.id === address.country
                    )?.name
                  }}
                </div>
              </div>
            </template>
          </BaseCard>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseCard from '@c/BaseCard'
import ToastUndoComponent from '@c/addf-package/components/BaseToast/ToastUndoComponent.vue'
import BaseSimpleSearchInput from '@c/addf-package/components/BaseInput/BaseSimpleSearchInput.vue'
//import cash from 'cash-dom/dist/cash'

export default {
  name: 'AddressModalList',
  components: { BaseSimpleSearchInput, ToastUndoComponent, BaseCard },
  props: {
    modelValue: {
      type: [String, Number],
      required: false,
      default: null
    },
    fullModelResponse: {
      type: Boolean,
      required: false,
      default: false
    },
    wikiAddress: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:modelValue', 'editAddress'],
  data() {
    return {
      filterText: ''
    }
  },
  computed: {
    ...mapGetters({
      initialMetadata: 'metadata/getInitialMetadata',
      addresses: 'address/getAddressList'
    }),
    addressList() {
      if (!this.wikiAddress) {
        return this.initialMetadata?.models?.addresses
      }
      return this.addresses
    },
    filteredAddresses() {
      if (!this.addressList) return []
      if (this.filterText.length < 1) {
        return this.addressList
      }
      const search = this.$h.normalizeSearch(this.filterText)
      return this.addressList?.filter(
        (address) =>
          this.$h.normalizeSearch(address?.name).includes(search) ||
          this.$h.normalizeSearch(address?.street).includes(search) ||
          this.$h.normalizeSearch(address?.city).includes(search) ||
          this.$h.normalizeSearch(address?.zip).includes(search)
      )
    },
    options() {
      return [
        [
          {
            label: this.$t('button.select'),
            icon: 'check',
            gate: true,
            action: (entry) => this.handleSelectAddress(entry)
          },
          {
            label: this.$t('button.edit'),
            icon: 'edit',
            gate: true,
            action: (entry) => {
              this.$emit('editAddress', entry.id)
            }
          }
        ],
        [
          {
            label: this.$t('button.delete'),
            icon: 'trash',
            gate: true,
            bg_color: 'bg-gradient-to-b from-red-600 to-red-700',
            txt_color: 'text-white',
            action: (entry) => this.deleteAddress(entry.id)
          }
        ]
      ]
    }
  },
  methods: {
    ...mapActions({
      processDeleteAddressByIdAction: 'address/deleteAddressById',
      processUndoDeleteAddressByIdAction: 'address/undoDeleteAddressById',
      processRefreshSpecificInitialMetadataModelsAction:
        'metadata/refreshSpecificInitialMetadataModels'
    }),
    handleSelectAddress(address) {
      this.$emit('update:modelValue', address)
      this.$emit('editAddress', address.id)
    },
    deleteAddress(id) {
      this.processDeleteAddressByIdAction({
        id: id,
        successCallback: () => {
          this.processRefreshSpecificInitialMetadataModelsAction({
            model: 'addresses'
          })
          this.$h.toastAction(
            'delete',
            this.$t('toasts.deleted_f', { var: this.$t('attributes.address') })
          )
        }
      })
    },
    undoDeleteAddress(id) {
      this.processUndoDeleteAddressByIdAction({
        id: id,
        successCallback: () => {
          this.processRefreshSpecificInitialMetadataModelsAction({
            model: 'addresses'
          })
          this.$h.toastify(this.$t('toasts.reseted_address'), {
            className: 'toastify-content success'
          })
        }
      })
    }
  }
}
</script>
